// store.js
import { writable } from 'svelte/store';

export const db = writable(null);
export const activeConversation = writable(null);  // add this line
export const userID = writable("");
//

export const clientUserID = writable("");
//

export const splashScreenArtUrl = writable(null);
export const assistantIconUrl = writable(null);
export const textCopy = writable(null);
export const modesData = writable(new Map());
export const selectedMode = writable(null);
export const isModesToggleExpanded = writable(false); // Default to false
export const emailHash = writable('');
//

export const isModesAvailable = writable(false); // Default to false
export const isWLtriggered = writable(false);
export const countDownTimer = writable(0); // This store will hold the countdown time
export const showCountdown = writable(false); // New store to control visibility explicitly
export const socketStore = writable(null);
export const isStreaming = writable(false);

export const footerLinkData = writable({});


export const isStatelessUserFlag = writable(false);
export const statelessMessages = writable([{ type: 'system', text: 'You are a helpful assistant.', modeId: null, messageId: 'default-system-message' }]);

// Function to add a message to the conversation
export function addStatelessMessage(newMessage) {
statelessMessages.update(currentMessages => [...currentMessages, newMessage]);
}

// Function to clear all messages except the default system message
export function clearStatelessMessages() {
statelessMessages.set([{ role: 'system', content: 'You are a helpful assistant.' }]);
}

//statelessMessages, addStatelessMessage, clearStatelessMessages
export const daChatToken = writable('');

export const daMessageId = writable('');



export const isCollapsed = writable(true);